module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-1.821d7eaf.jpg";